/**
 * SectionError Component
 * Displays inline error state with retry button for dashboard sections
 */

import { AlertCircle } from "lucide-react";
import { ZButton } from "@/shared/components/button";

interface SectionErrorProps {
  title: string;
  description?: string;
  onRetry: () => void;
}

export const SectionError = ({
  title,
  description,
  onRetry,
}: SectionErrorProps) => {
  return (
    <div className="flex flex-col items-center justify-center p-6 rounded-lg min-h-[120px]">
      <AlertCircle className="w-8 h-8 text-danger mb-2" />
      <p className="text-danger font-medium text-sm">{title}</p>
      
      <ZButton
        variant="flat"
        color="danger"
        size="sm"
        className="mt-3"
        onClick={onRetry}
      >
        Try Again
      </ZButton>
    </div>
  );
};

export default SectionError;
